export default {
  "Design Research": {
    title: "Design Research",
    description:
      "Design Research is the customer-focused approach that helps to better understand the underlying and sometimes hidden desires, needs, and challenges of end users.",
    links: [
      {
        iconType: "article",
        title: "Complete Beginner’s Guide to UX Research",
        href: "https://www.uxbooth.com/articles/complete-beginners-guide-to-design-research/",
      },
      {
        iconType: "article",
        title: "The 9 Rules of Design Research",
        href: "https://medium.com/mule-design/the-9-rules-of-design-research-1a273fdd1d3b",
      },
      {
        iconType: "article",
        title: "UX Research Cheat Sheet",
        href: "https://www.nngroup.com/articles/ux-research-cheat-sheet/",
      },
      {
        iconType: "article",
        title: "ResearchOps 101",
        href: "https://www.nngroup.com/articles/research-ops-101/",
      },
      {
        iconType: "article",
        title: "17 Tools That Will Streamline Your UX Research",
        href: "https://uxtools.co/blog/17-tools-that-will-streamline-your-ux-research/",
      },
    ],
  },
  Interviews: {
    title: "Interviews",
    description:
      "Interview is the research method during which we ask a user questions about a topic of interest (e.g., product usage, behaviors, and habits) in a one-on-one session. The purpose of the interview is to get a better understanding of important information about users: their backgrounds, beliefs, motivations, desires, or needs.",
    links: [
      {
        iconType: "article",
        title: "User Interviews: How, When, and Why to Conduct Them",
        href: "https://www.nngroup.com/articles/user-interviews/",
      },
      {
        iconType: "article",
        title: "Exploratory Design Research Interview",
        href: "https://medium.com/designstrat/exploratory-design-research-interview-dc51398c6354",
      },
      {
        iconType: "article",
        title: "Writing an Effective Guide for a UX Interview",
        href: "https://www.nngroup.com/articles/interview-guide/",
      },
      {
        iconType: "article",
        title:
          "6 Tips from IDEO Designers on How to Unlock Insightful Conversation",
        href: "https://www.ideou.com/blogs/inspiration/6-tips-from-ideo-designers-on-how-to-unlock-insightful-conversation",
      },
    ],
  },
  Surveys: {
    title: "Surveys",
    description:
      "Survey is the research method to collect information from respondents by asking multiple survey questions. It helps to measure users' responses, satisfaction, and pain points which in turn enables the team to make more informed decisions around their design approach and/or feature prioritization.",
    links: [
      {
        iconType: "article",
        title: "28 Tips for Creating Great Qualitative Surveys",
        href: "https://www.nngroup.com/articles/qualitative-surveys/?ref=uxtools-challenges",
      },
      {
        iconType: "article",
        title: "Best practices for every step of survey creation",
        href: "https://www.surveymonkey.com/mp/survey-guidelines/",
      },
      {
        iconType: "article",
        title: "This is all you need to know to conduct a UX Survey",
        href: "https://uxplanet.org/this-is-all-you-need-to-know-to-conduct-a-ux-survey-50400af45920",
      },
    ],
  },
  "Contextual Inquiry": {
    title: "Contextual Inquiry",
    description:
      "Contextual inquiry is the form of an interview, where users are observed and questioned in their own environment or context in which a design will be used.",
    links: [
      {
        iconType: "article",
        title: "What are Contextual Interviews?",
        href: "https://www.interaction-design.org/literature/topics/contextual-interviews",
      },
      {
        iconType: "article",
        title:
          "Contextual Inquiry: Inspire Design by Observing and Interviewing Users in Their Context",
        href: "https://www.nngroup.com/articles/contextual-inquiry/",
      },
      {
        iconType: "article",
        title: "Why Are Contextual Inquiries More Difficult?",
        href: "https://www.uxmatters.com/mt/archives/2012/06/why-are-contextual-inquiries-so-difficult.php#:~:text=The%20key%20differentiator%20between%20contextual,while%20they%20are%20doing%20it.",
      },
    ],
  },
  "Competitive Research": {
    title: "Competitive Research",
    description:
      "Competitive research is the comprehensive analysis of competitors' products or services. This type of research helps product teams to understand industry standards and identify opportunities for the product in a given market segment. As a result, the product team will be given a report analysis in a comparable way.",
    links: [
      {
        iconType: "article",
        title: "A Product Designer's Guide to Competitive Analysis",
        href: "https://www.toptal.com/product-managers/freelance/product-designer-guide-to-competitive-analysis",
      },
      {
        iconType: "article",
        title: "A Guide to Competitive Analysis for UX Design",
        href: "https://xd.adobe.com/ideas/process/user-research/guide-to-competitive-analysis-ux-design/",
      },
      {
        iconType: "article",
        title: "Top Things to Know About UX Competitive Analysis",
        href: "https://uxplanet.org/top-things-to-know-about-ux-competitive-analysis-d91689fd8b36",
      },
      {
        iconType: "article",
        title: "UX Strategy: Chapter 4. Conducting Competitive Research",
        href: "https://www.oreilly.com/library/view/ux-strategy/9781449372972/ch04.html",
      },
    ],
  },
  "SWOT Analysis": {
    title: "SWOT Analysis",
    description:
      "SWOT analysis is the strategic planning and management technique used to help a product team to identify Strengths, Weaknesses, Opportunities, and Threats related to business competition or project planning.",
    links: [
      {
        iconType: "article",
        title: "SWOT Analysis",
        href: "https://www.investopedia.com/terms/s/swot.asp",
      },
      {
        iconType: "article",
        title: "Let’s Talk About SWOT Analysis",
        href: "https://medium.com/s/how-to-build-a-brand/lets-talk-about-swot-analysis-a49f825406fa",
      },
      {
        iconType: "video",
        title: "How to Perform a SWOT Analysis",
        href: "https://www.youtube.com/watch?v=I_6AVRGLXGA",
      },
    ],
  },
  "Qualitative Research": {
    title: "Qualitative Research",
    description:
      "Qualitative research relies on the data obtained from first-hand observations, interviews, questionnaires, focus groups, and recordings made in natural settings.",
    links: [
      {
        iconType: "video",
        title: "5 Qualitative Research Methods",
        href: "https://www.youtube.com/watch?v=dyHMTaQJmYo",
      },
      {
        iconType: "video",
        title: "Comparing Qualitative and Quantitative UX Research",
        href: "https://www.youtube.com/watch?v=qvpitkHcIGk",
      },
      {
        iconType: "article",
        title: "Qualitative Usability Testing: Study Guide",
        href: "https://www.nngroup.com/articles/qual-usability-testing-study-guide/",
      },
    ],
  },
  "Quantitative Research": {
    title: "Quantitative Research",
    description:
      "Quantitative research is the research strategy that focuses on quantifying and analysis of data obtained from web/app analytics, surveys, questionaries, card sorting, and tree testing.",
    links: [
      {
        iconType: "article",
        title: "What is Quantitative Research?",
        href: "https://www.interaction-design.org/literature/topics/quantitative-research",
      },
      {
        iconType: "article",
        title: "Quantitative User-Research Methodologies: An Overview",
        href: "https://www.nngroup.com/articles/quantitative-user-research-methods/",
      },
      {
        iconType: "video",
        title: "Qualitative vs. Quantitative UX Research",
        href: "https://www.youtube.com/watch?v=LmWPygSxMms",
      },
    ],
  },
  "Task Analysis": {
    title: "Task Analysis",
    description:
      "Task analysis is the systematic method of studying the tasks which users perform in order to reach their goals.",
    links: [
      {
        iconType: "article",
        title: "How to improve your UX designs with Task Analysis",
        href: "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend",
      },
      {
        iconType: "article",
        title: "Task Analysis: Support Users in Achieving Their Goals",
        href: "https://www.nngroup.com/articles/task-analysis/",
      },
      {
        iconType: "article",
        title: "Evaluative Methods: Task Analysis",
        href: "https://www.userinterviews.com/ux-research-field-guide-chapter/task-analysis",
      },
      {
        iconType: "article",
        title:
          "UX Metrics: Identify Trackable Footprints and Avoid the Woozles",
        href: "https://articles.uie.com/ux-metrics-identify-trackable-footprints-and-avoid-the-woozles/",
      },
    ],
  },
  Analytics: {
    title: "Analytics",
    description:
      "UX analytics is the measurement and analysis of the user activity on a website or app that provides insights into how design can be adapted to meet the current or changing needs of end users. ",
    links: [
      {
        iconType: "article",
        title: "Data-informed design: Getting started with UX analytics",
        href: "https://mixpanel.com/blog/what-is-ux-analytics/",
      },
      {
        iconType: "article",
        title: "The ultimate guide to Google Analytics for UX designers",
        href: "https://uxdesign.cc/google-analytics-ux-alice-emma-walker-958d6f0f0af3",
      },
    ],
  },
  "A/B Testing": {
    title: "A/B Testing",
    description:
      "A/B testing is the research method of comparing two versions of a webpage or app against each other to determine which one performs better.",
    links: [
      {
        iconType: "video",
        title: "A/B Testing 101",
        href: "https://www.youtube.com/watch?v=m000dSSXvDY",
      },

      {
        iconType: "article",
        title: "7 steps of A/B testing",
        href: "https://uxdesign.cc/7-steps-of-a-b-testing-what-how-cf3b209467fd",
      },

      {
        iconType: "article",
        title: "6 Essential Tips for Effective A/B Testing",
        href: "https://xd.adobe.com/ideas/process/user-testing/effective-ab-testing-essential-tips/",
      },

      {
        iconType: "article",
        title: "Define Stronger A/B Test Variations Through UX Research",
        href: "https://www.nngroup.com/articles/ab-testing-and-ux-research/",
      },
      {
        iconType: "video",
        title:
          "Netflix Product Designer | Navin Iyengar | Design Like a Scientist",
        href: "https://www.youtube.com/watch?v=XRd6Ddn4ZSY",
      },
    ],
  },
  "Card Sorting": {
    title: "Card Sorting",
    description:
      "Card sorting is the research method in which participants organize topics into groups. This technique helps to create or evaluate the information architecture of a product.",
    links: [
      {
        iconType: "article",
        title:
          "Card Sorting: Uncover Users' Mental Models for Better Information Architecture",
        href: "https://www.nngroup.com/articles/card-sorting-definition/",
      },
      {
        iconType: "article",
        title: "Card sorting: a powerful, simple research method",
        href: "https://medium.com/design-ibm/card-sorting-a-powerful-simple-research-method-9d1566be9b62",
      },
      {
        iconType: "article",
        title: "Card Sorting Best Practices for UX",
        href: "https://xd.adobe.com/ideas/process/information-architecture/card-sorting-best-practices/",
      },
    ],
  },

  "Research Repository": {
    title: "Research Repository",
    description:
      "A research repository is the shared collection of UX-research-related elements that should support the following functions at the organization level: grow UX awareness and participation in UX work among leadership, product owners, and the organization at large.",
    links: [
      {
        iconType: "article",
        title:
          "Research Repositories for Tracking UX Research and Growing Your ResearchOps",
        href: "https://www.nngroup.com/articles/research-repositories/",
      },
      {
        iconType: "video",
        title:
          "Research repository: solving your organization’s research problems",
        href: "https://www.youtube.com/watch?v=patVa8wDdUI",
      },
    ],
  },
  "Research Planning": {
    title: "Research Planning",
    description:
      "Research planning is the process of preparing a research plan that outlines the project goals, strategies, and initiatives. Usually, it is supposed to be a shared file that provides an opportunity for product teams and stakeholders to be aligned on the desired research outcomes and values. ",
    links: [
      {
        iconType: "article",
        title: "The UX Research Plan That Stakeholders Love",
        href: "https://www.smashingmagazine.com/2012/01/ux-research-plan-stakeholders-love/",
      },
      {
        iconType: "video",
        title: "Creating a UX Research Plan",
        href: "https://www.youtube.com/watch?v=VKl8X16GoiY",
      },
    ],
  },
  "Analysis of Findings": {
    title: "Analysis of Findings",
    description:
      "Analysis of findings is the process of interpreting data into meaningful results. Commonly, researchers or designers compile these results into reports and store them in online repositories.",
    links: [
      {
        iconType: "article",
        title:
          "How to Analyze Qualitative Data from UX Research: Thematic Analysis",
        href: "https://www.nngroup.com/articles/thematic-analysis/",
      },
      {
        iconType: "video",
        title: "Thematic Analysis of Qualitative User Research Data",
        href: "https://www.youtube.com/watch?v=KUZ6iGvJlGI",
      },

      {
        iconType: "article",
        title: "A Guide to User Research Analysis",
        href: "https://www.uxbooth.com/articles/a-guide-to-user-research-analysis/",
      },

      {
        iconType: "article",
        title: "Design Research From Interview to Insight",
        href: "https://medium.com/design-research-methods/design-research-from-interview-to-insight-f6957b37c698",
      },
      {
        iconType: "article",
        title: "Quicker UX Research Synthesis",
        href: "https://uxtools.co/blog/quicker-ux-research-synthesis/",
      },
    ],
  },
};
